import React from 'react';

/**
 * AI Image Editor trigger button
 * Displays a small "AI" button that opens the AI image editing modal
 */
function AiImageEditorButton({ onClick, disabled }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="
        px-2 py-1
        text-xs font-bold
        bg-gradient-to-r from-purple-500 to-pink-500
        hover:from-purple-600 hover:to-pink-600
        disabled:from-gray-400 disabled:to-gray-400
        text-white
        rounded-md
        shadow-sm
        hover:shadow-md
        transition-all duration-200
        flex items-center gap-1
      "
      title="Open AI Image Editor"
    >
      <svg 
        className="w-3 h-3" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M13 10V3L4 14h7v7l9-11h-7z" 
        />
      </svg>
      AI
    </button>
  );
}

export default AiImageEditorButton;
